import * as o from "react";
import t from "../lib/IconBase.es.js";
import a from "../defs/FolderLock.es.js";
const e = o.forwardRef((r, c) => /* @__PURE__ */ o.createElement(t, { ref: c, ...r, weights: a }));
e.displayName = "FolderLockIcon";
const n = e;
export {
  n as FolderLock,
  e as FolderLockIcon
};
